import React from 'react';
import ReactMarkdown from 'react-markdown';
import { AlertContext, AlertContextType, AlertSetType, ServicesContext } from '~/services';
import { ErrorModal } from '~/components/Errors';
import { enumValue } from '~/util';
import { BSModal } from '~/components/Bootstrap';
import { Modal } from 'react-bootstrap';
import { MdLink } from '~/components/Markdown/MdLink';

export function Alert() {
    const alertContext = React.useContext(AlertContext) as AlertContextType;
    const servicesContext = React.useContext(ServicesContext);

    if (alertContext.alerts.length === 0) return null;

    function isAnnouncementBanner(id: AlertSetType['id']) {
        return typeof id === 'string' && id.includes('announcement-');
    }

    function dismiss(id: AlertSetType['id']) {
        if (typeof id === 'string' && isAnnouncementBanner(id)) {
            servicesContext.user.dismissBanner(id.replace('announcement-', ''));
        }
        alertContext.dismiss(id);
    }

    function display(alert: AlertSetType) {
        if (alert.banner === enumValue(['banners', 'type', 'Banner'])) {
            return (
                <div
                    className={`d-flex justify-content-center alert alert-${alert.type} ${
                        isAnnouncementBanner(alert.id) ? 'alert-announcement' : 'alert-system'
                    }`}
                    role="alert"
                    key={alert.id}
                >
                    {isAnnouncementBanner(alert.id) ? (
                        <ReactMarkdown
                            components={{
                                a: MdLink,
                            }}
                            className="flex-grow-1"
                        >
                            {alert.content as string}
                        </ReactMarkdown>
                    ) : (
                        <span className="flex-grow-1">{alert.content}</span>
                    )}
                    <button
                        type="button"
                        className="modal-close-button d-flex"
                        aria-label="Close"
                        onClick={() => dismiss(alert.id)}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            );
        }
        if (alert.banner === enumValue(['banners', 'type', 'Modal'])) {
            return (
                <BSModal
                    onHide={() => dismiss(alert.id)}
                    show
                    aria-labelledby="alert-modal-title"
                    id={alert.id}
                    key={alert.id}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="alert-modal-title" role="heading" aria-level={1}>
                            {alert.type}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ReactMarkdown
                            components={{
                                a: MdLink,
                            }}
                        >
                            {alert.content as string}
                        </ReactMarkdown>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => dismiss(alert.id)}
                        >
                            Close
                        </button>
                    </Modal.Footer>
                </BSModal>
            );
        }
        return (
            <ErrorModal
                show
                description={alert.content}
                title={alert.type}
                handleClose={() => dismiss(alert.id)}
                key={alert.id}
            />
        );
    }

    return <div className="system-alert">{alertContext.alerts.map((alert) => display(alert))}</div>;
}
